import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { all_routes } from "../router/all_routes";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import { InputOtp } from "primereact/inputotp";
import { Link } from "react-router-dom";
import CopyRightInfo from "../../core/common/copyRightInfo";
import useFetch from "../../hooks/useFetch";
import PreLoader from "../../core/common/preLoader";
import { API } from "../../common/Constants";
import { setAuthToken, setTenantID } from "../../common/Utils";
import HeaderLogo from "../../core/common/headerLogo";

const OTPVerification = () => {
  const routes = all_routes;
  const navigation = useNavigate();
  const [searchParams] = useSearchParams();
  const {isLoading, error, callFetch } = useFetch();

  const [username, setUserName] = useState<string | undefined>(undefined);
  const [tenant, setTenant] = useState<string | undefined>(undefined);
  const [otp, setOTP] = useState<any>(undefined);
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
  const [resendMessage, setResendMessage] = useState<string | undefined>("");
  const [timer, setTimer] = useState<number>(120); // 2 minutes in seconds
  const [isResendDisabled, setIsResendDisabled] = useState<boolean>(true);

  useEffect(() => {
    let usr = searchParams.get("username")
    let tnt = searchParams.get("tenant")
    if (usr){
      setUserName(usr)
    }
    if (tnt) {
      setTenant(tnt);
    }
  }, [searchParams]);

  // Timer implementation
  useEffect(() => {
    let interval: NodeJS.Timeout | undefined;
    
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else {
      setIsResendDisabled(false);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [timer]);

  useEffect(() => {
    if(error){
      setResendMessage("")
      if(error.response?.data){
        setErrorMessage(error.response?.data)
      } else{
        setErrorMessage('Something went wrong please try again later.')
      }
    }
  }, [error]);

  const reset = () => {
      setUserName(undefined)
      setOTP(undefined)
      setErrorMessage("")
      setResendMessage("")
      setTimer(120);
  }

  const handleSubmit = (event:any) => {
    event.preventDefault()
    if(!username){
      setErrorMessage("Please provide username")
    } else if (!otp){
      setErrorMessage("Please provide OTP")
    } else {
      setErrorMessage("")
      callFetch(API.VERIFY_OTP,
          'POST',
          {
              'X-Tenant-ID': tenant,
          },
          null,
          {
              username: username,
              otp: otp,
          }
      ).then((res)=>{
        setAuthToken(res.token)
        setTenantID(tenant)
        navigation(routes.resetPassword + "?username=" + username);
        reset();
      }).catch((err) => {
     
      });
    }
  }

  const handleResendSubmit = (event:any) => {
    event.preventDefault();
    if(isResendDisabled) return; // Prevent resending if timer is still active
    
    if(!username){
      setErrorMessage("Please provide username")
    } else {
      setErrorMessage("")
      callFetch(API.RESET_PASSWORD,
          'POST',
          {
              'X-Tenant-ID': tenant,
          },
          null,
          {
              username: username,
          }
      ).then((res)=>{
        setResendMessage("OTP sent to your registered email id.")
        // Reset timer and disable resend button
        setTimer(120);
        setIsResendDisabled(true);
      }).catch((err) => {
        setErrorMessage("Failed to resend OTP. Please try again.");
      });
    }
  }

  // Format the timer as MM:SS
  const formatTime = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  return (
    <div className="container-fuild">
      <PreLoader showLoader={isLoading} />
      <div className="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
        <div className="row">
          <div className="col-lg-5">
            <div className="d-lg-flex align-items-center justify-content-center d-none flex-wrap vh-100 bg-primary-transparent">
              <div>
                <ImageWithBasePath src="assets/img/bg/authentication-bg-08.svg" alt="Img" />
              </div>
            </div>
          </div>
          <div className="col-lg-7 col-md-12 col-sm-12">
            <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap ">
              <div className="col-md-7 mx-auto p-4">
                <form>
                  <div>
                    <div className="d-flex mx-auto mb-5 text-center justify-content-center">
                      <HeaderLogo />
                    </div>
                    <div className="">
                      <div className="text-center mb-3">
                        <h2 className="mb-2">2 Step Verification</h2>
                        <p className="mb-0">
                          Please enter the OTP received on your registered email id to confirm your account
                          ownership.
                        </p>
                      </div>
                      <div className="text-center otp-input">
                        <div className="d-flex align-items-center mb-3">
                           <InputOtp value={otp} onChange={(e) => setOTP(e.value)} integerOnly />
                        </div>
                        <div>
                          <div className="badge bg-danger-transparent mb-3">
                            <p className="d-flex align-items-center ">
                              <i className="ti ti-clock me-1" />
                              {formatTime(timer)}
                            </p>
                          </div>
                          <div className="mb-3">
                            {
                              <div className="text-center" style={{height:12}}>
                                {
                                  errorMessage
                                  ?
                                    <>
                                      <span className="link-danger">
                                      <i className="ti ti-alert-triangle" /> {errorMessage}
                                      </span>
                                    </>
                                  :
                                  resendMessage
                                  ?
                                  <>
                                    <span className="link-success">
                                    <i className="ti ti-alert-circle" /> {resendMessage}
                                    </span>
                                  </>
                                  : <></>
                                  }
                                </div>
                            }
                          </div>
                          <div className="mb-3 d-flex justify-content-center">
                            <p className="text-gray-9">
                              Didn't get the OTP?{" "}
                              <Link
                                to="#"
                                className={`text-primary ${isResendDisabled ? 'disabled-link' : ''}`}
                                onClick={handleResendSubmit}
                                style={{
                                  pointerEvents: isResendDisabled ? 'none' : 'auto',
                                  opacity: isResendDisabled ? 0.6 : 1,
                                  textDecoration: 'none'
                                }}
                              >
                                Resend OTP
                              </Link>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="mb-3">
                        <button type="submit" onClick={handleSubmit} className="btn btn-primary w-100">
                          Verify &amp; Proceed
                        </button>
                      </div>
                    </div>
                    <div className="mt-5 text-center">
                      <CopyRightInfo/>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OTPVerification;